document.addEventListener("DOMContentLoaded", function () {
  const picker = document.querySelector("product-option-picker");
  if (!picker) return;
  const btn = picker.querySelector("#sizeChartBtn");
  const drawer = document.querySelector(".size-chart-drawer");
  if (!btn || !drawer) return;
  const closeBtn = drawer.querySelector(".size-chart-drawer__close");

  document.body.appendChild(drawer);

  function openDrawer() {
    drawer.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.classList.remove("open");
    document.body.style.overflow = "";
  }

  btn.addEventListener("click", openDrawer);

  if (closeBtn) {
    closeBtn.addEventListener("click", closeDrawer);
  }

  drawer.addEventListener("click", function (e) {
    if (!e.target.closest(".size-chart-drawer__content")) closeDrawer();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("open")) closeDrawer();
  });
});
